function HelpCenter() {
    return (
       <div className="help-comp">
          <div className="help-content">
             <h1>We’re here if you need us</h1>
             <img src="https://animoto.com/static/wavy-e1cf461e1a9e7fed09a8a00a53c93f7f.svg" alt="curve-line" width="130px" />
             <div>
                As you get started making videos, we're here to help along the way!
                Join other businesses just like yours in the <span>Animoto Social Video Marketing Community</span> on Facebook.
                Our team of video experts is ready to help you grow with tips, ideas, inspiration, and feedback on your videos.
                You can also reach our dedicated Customer team directly at <span>help@animoto.com</span>.
             </div>
             <button className='btn'>VISIT OUR HELP CENTER</button>
          </div>
          <div>
             <img src="https://images.ctfassets.net/00i767ygo3tc/1Srdp2yWuy6mXjPDBiKcd8/7db3b0b74c0f5435867daabca94644bc/2022_CommunityFooterImager-March.png?w=1209&h=768&q=80&fm=webp" alt="help" />
          </div>
       </div>
    );
 }
 
 export default HelpCenter;